<template>
  <div>
    <InputText v-model="fieldValue" :disabled="disabled"></InputText>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "DynamicInputText",
  props: ['uniqueId', 'disabled'],
  data() {
    return {
      // fieldValue: ''
    }
  },
  computed: {
    ...mapGetters('search', [
      'getData'
    ]),
    fieldValue: {
      get() {
        return this.getData(this.uniqueId);
      },
      set(data) {
        this.setData({uniqueId: this.uniqueId, data: [data]})
      }
    },


  },
  methods: {
    ...mapActions('search', [
      'setData'
    ]),
  },
}
</script>

<style scoped>

</style>